<template>
  <QBtn
    flat
    dense
    :icon="$q.dark.isActive?'light_mode':'dark_mode'"
    class="text-light-icon"
    @click="onClick"
  />
</template>

<script setup>
import { useQuasar } from 'quasar'
import { useConfigStore } from '@/stores/config.js'

const config = useConfigStore()
const $q = useQuasar()

$q.dark.set(config.darkMode)

function onClick () {
  $q.dark.toggle()
  config.darkMode = $q.dark.isActive
}

</script>
